module.exports = __webpack_public_path__ + "static/img/strona_032.9e00f10a.jpg";